import ReactCardFlip from "react-card-flip";
import "../css/aboutme.css";

function SkillFlipCard({ img, label, years, isFlipped, onFlip }) {
  return (
    <ReactCardFlip flipDirection="horizontal" isFlipped={isFlipped}>
      {/* FRONT */}
      <div className="skill_tool_card" onClick={onFlip}>
        <div className="skill_tool_inner">
          <img src={img} alt={label} />
          <p>{label}</p>
        </div>
      </div>

      {/* BACK */}
      <div className="skill_tool_card" onClick={onFlip}>
        <div className="skill_tool_inner">
          <p>{years} years of experience</p>
        </div>
      </div>
    </ReactCardFlip>
  );
}

export default SkillFlipCard;